export default "__VITE_ASSET__BXZJqOVT__"